import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatKeyword } from '@bingads-webui-campaign/recommendation-core';

export class SuggestedKeywordColumn extends ProjectionGridBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'SuggestedKeyword',
      property: 'Opportunities/SuggestedKeyword',
      title: i18n.getString('Details_View_Keyword'),
      bodyClasses: ['grid-column-keyword'],
      colClasses: ['col-longText'],
      type: 'string',
    });
  }

  template({ value: { SuggestedKeyword, MatchType, NewMatchType } }) {
    // If match type is changed, use new match type to format keyword.
    return formatKeyword(SuggestedKeyword, NewMatchType || MatchType);
  }

  get property() {
    return {
      get(item) {
        return _.chain(item.Opportunities).first().value();
      },
      key: 'Opportunities/SuggestedKeyword',
    };
  }
}
